import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest, IQueryResultSettings } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './AlternateItemsEntity.g';

function getItemIdsQuery(): DataServiceQuery {
  return new DataServiceQuery();
  }

export function getItemIdsInput (
queryResultSettings: IQueryResultSettings, fitmentSearchCriteria:
    DataServiceEntities.IGCFitmentSearchCriteria
): IDataServiceRequest {
const query = getItemIdsQuery().resultSettings(queryResultSettings);
return query.createDataServiceRequestForOperation(
  'GetItemIds',
  true,
    DataServiceEntities.ItemIdsExtensionClass
  ,
  'true',
  { bypassCache: 'get', returnEntity: 'DataServiceEntities.IItemIds' },
  {
  fitmentSearchCriteria: fitmentSearchCriteria
  }
);
}

export function getItemIdsAsync (
context: IContext, fitmentSearchCriteria:
    DataServiceEntities.IGCFitmentSearchCriteria
): AsyncResult<DataServiceEntities.IItemIds[]> {
const request = getItemIdsInput(
  context.queryResultSettings || {}, fitmentSearchCriteria);
return callActionOrExecute<DataServiceEntities.IItemIds[]>(request, context.callerContext);
}